import * as React from 'react'
const Spinner = require('spin')

export interface Props {
  stopped: boolean
  options?: any
}

export default class ReactSpinner extends React.Component<Props> {
  private spinner: Spinner
  private container?: HTMLElement

  componentDidMount () {
    this.spinner = new Spinner(this.props.options)
    if (!this.props.stopped) {
      this.spinner.spin(this.container)
    }
  }

  componentWillReceiveProps (nextProps: Props) {
    if (nextProps.stopped === true && !this.props.stopped) {
      this.spinner.stop()
    } else if (!nextProps.stopped && this.props.stopped === true) {
      this.spinner.spin(this.container)
    }
  }

  componentWillUnmount () {
    this.spinner.stop()
  }

  render () {
    return <span ref={this._onRef} />
  }

  private _onRef = (container: HTMLElement) => {
    this.container = container
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Spinner.tsx